import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('TransactionLog', {params});
    },
    McrChangeLog(params) {
        return Service().get('McrChangeLog/'+params);
    }, 
    export(params) {
        return Service().get('TransactionLog/export/', {params});
    },    
}